import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const WishlistContext = createContext({});
export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("wishlist") || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("wishlist", JSON.stringify(items)); }, [items]);
  const has = (id) => items.some((i) => i.id === id);
  const toggle = (p) => {
    setItems((cur) => {
      if (cur.some((i) => i.id === p.id)) { toast.success("Removed from wishlist"); return cur.filter((i) => i.id !== p.id); }
      toast.success("Added to wishlist");
      return [...cur, { id: p.id, name: p.name, brand: p.brand, price: p.price, image: p.images?.[0] }];
    });
  };
  const remove = (id) => setItems((c) => c.filter((i) => i.id !== id));
  return <WishlistContext.Provider value={{ items, toggle, has, remove, count: items.length }}>{children}</WishlistContext.Provider>;
};
export const useWishlist = () => useContext(WishlistContext);
